/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Asset from '../model/Asset';
import Cart from '../model/Cart';
import Subclip from '../model/Subclip';

/**
* Cart service.
* @module api/CartApi
* @version 1.0.0
*/
export default class CartApi {

    /**
    * Constructs a new CartApi. 
    * @alias module:api/CartApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the addAssetsToCart operation.
     * @callback module:api/CartApi~addAssetsToCartCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/Asset>} [asset] 
     * @param {module:api/CartApi~addAssetsToCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    addAssetsToCart(cartUuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['asset'];
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling addAssetsToCart");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/asset/add/{cartUuid}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the addCart operation.
     * @callback module:api/CartApi~addCartCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Boolean} [overwrite = false)] 
     * @param {module:model/Cart} [cart] 
     * @param {module:api/CartApi~addCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    addCart(opts, callback) {
      opts = opts || {};
      let postBody = opts['cart'];

      let pathParams = {
      };
      let queryParams = {
        'overwrite': opts['overwrite']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/add', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the addSubclipsToCart operation.
     * @callback module:api/CartApi~addSubclipsToCartCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/Subclip>} [subclip] 
     * @param {module:api/CartApi~addSubclipsToCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    addSubclipsToCart(cartUuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['subclip'];
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling addSubclipsToCart");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/subclip/add/{cartUuid}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCartById operation.
     * @callback module:api/CartApi~getCartByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {module:api/CartApi~getCartByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    getCartById(cartUuid, callback) {
      let postBody = null;
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling getCartById");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/{cartUuid}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCarts operation.
     * @callback module:api/CartApi~getCartsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Cart>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {String} [search] 
     * @param {String} [user] 
     * @param {Number} [limit] 
     * @param {module:api/CartApi~getCartsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Cart>}
     */
    getCarts(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'user': opts['user'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Cart];
      return this.apiClient.callApi(
        '/cart', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCartsByIds operation.
     * @callback module:api/CartApi~getCartsByIdsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Cart>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} [requestBody] 
     * @param {module:api/CartApi~getCartsByIdsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Cart>}
     */
    getCartsByIds(opts, callback) {
      opts = opts || {};
      let postBody = opts['requestBody'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = [Cart];
      return this.apiClient.callApi(
        '/cart', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCartsByName operation.
     * @callback module:api/CartApi~getCartsByNameCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Cart>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} name 
     * @param {module:api/CartApi~getCartsByNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Cart>}
     */
    getCartsByName(name, callback) {
      let postBody = null;
      // verify the required parameter 'name' is set
      if (name === undefined || name === null) {
        throw new Error("Missing the required parameter 'name' when calling getCartsByName");
      }

      let pathParams = {
        'name': name
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Cart];
      return this.apiClient.callApi(
        '/cart/name/{name}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the removeAssetsFromCart operation.
     * @callback module:api/CartApi~removeAssetsFromCartCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {Object} opts Optional parameters
     * @param {Boolean} [moveToHiddenAssets = true)] 
     * @param {Boolean} [removeAssets = false)] 
     * @param {Array.<String>} [requestBody] 
     * @param {module:api/CartApi~removeAssetsFromCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    removeAssetsFromCart(cartUuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['requestBody'];
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling removeAssetsFromCart");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
        'moveToHiddenAssets': opts['moveToHiddenAssets'],
        'removeAssets': opts['removeAssets']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/asset/remove/{cartUuid}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the removeCart operation.
     * @callback module:api/CartApi~removeCartCallback
     * @param {String} error Error message, if any.
     * @param {Boolean} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {Object} opts Optional parameters
     * @param {Object.<String, Object>} [body] Optional description in *Markdown*
     * @param {module:api/CartApi~removeCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Boolean}
     */
    removeCart(cartUuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling removeCart");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = 'Boolean';
      return this.apiClient.callApi(
        '/cart/{cartUuid}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the removeSubclipsFromCart operation.
     * @callback module:api/CartApi~removeSubclipsFromCartCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} [requestBody] 
     * @param {module:api/CartApi~removeSubclipsFromCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    removeSubclipsFromCart(cartUuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['requestBody'];
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling removeSubclipsFromCart");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/subclip/remove/{cartUuid}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the renameSubclipFromCard operation.
     * @callback module:api/CartApi~renameSubclipFromCardCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartId 
     * @param {String} subclipId 
     * @param {String} name 
     * @param {module:api/CartApi~renameSubclipFromCardCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    renameSubclipFromCard(cartId, subclipId, name, callback) {
      let postBody = null;
      // verify the required parameter 'cartId' is set
      if (cartId === undefined || cartId === null) {
        throw new Error("Missing the required parameter 'cartId' when calling renameSubclipFromCard");
      }
      // verify the required parameter 'subclipId' is set
      if (subclipId === undefined || subclipId === null) {
        throw new Error("Missing the required parameter 'subclipId' when calling renameSubclipFromCard");
      }
      // verify the required parameter 'name' is set
      if (name === undefined || name === null) {
        throw new Error("Missing the required parameter 'name' when calling renameSubclipFromCard");
      }

      let pathParams = {
        'cartId': cartId
      };
      let queryParams = {
        'subclipId': subclipId,
        'name': name
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/subclip/rename/{cartId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the restoreCartById operation.
     * @callback module:api/CartApi~restoreCartByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {module:api/CartApi~restoreCartByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    restoreCartById(cartUuid, callback) {
      let postBody = null;
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling restoreCartById");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/restore/{cartUuid}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the restoreHiddenAssetsFromCart operation.
     * @callback module:api/CartApi~restoreHiddenAssetsFromCartCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} cartUuid 
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} [requestBody] 
     * @param {module:api/CartApi~restoreHiddenAssetsFromCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    restoreHiddenAssetsFromCart(cartUuid, opts, callback) {
      opts = opts || {};
      let postBody = opts['requestBody'];
      // verify the required parameter 'cartUuid' is set
      if (cartUuid === undefined || cartUuid === null) {
        throw new Error("Missing the required parameter 'cartUuid' when calling restoreHiddenAssetsFromCart");
      }

      let pathParams = {
        'cartUuid': cartUuid
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart/asset/restore/{cartUuid}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the submitCart operation.
     * @callback module:api/CartApi~submitCartCallback
     * @param {String} error Error message, if any.
     * @param {Boolean} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/Cart} [cart] 
     * @param {module:api/CartApi~submitCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Boolean}
     */
    submitCart(opts, callback) {
      opts = opts || {};
      let postBody = opts['cart'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = 'Boolean';
      return this.apiClient.callApi(
        '/cart/submit', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCart operation.
     * @callback module:api/CartApi~updateCartCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Cart} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/Cart} [cart] 
     * @param {module:api/CartApi~updateCartCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Cart}
     */
    updateCart(opts, callback) {
      opts = opts || {};
      let postBody = opts['cart'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Cart;
      return this.apiClient.callApi(
        '/cart', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
